export default __webpack_public_path__ + "static/media/0017.a65af3c8.jpg";